import type {ReactElement} from 'react'
import {SwiperSlide} from 'swiper/react'
import {useSwiper} from 'swiper/react'
import Image from 'next/image'
import React, { useState } from 'react'

interface Props {
  image: any
  onLoad: () => void
  loaded: boolean
}
export default function ProductSliderItem({image, onLoad, loaded}: Props): ReactElement {
  const swiper = useSwiper()
  const [imageError, setImageError] = useState(false)

  return (
    <>
      <div className="w-full relative h-[250px] lg:h-[480px] xl:h-[480px]">
        {/* Skeleton loader */}
        {!loaded && !imageError && (
          <div className="absolute inset-0 bg-gray-200 animate-pulse rounded-lg flex items-center justify-center">
            <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        
        {/* Image */}
        <img
          src={process.env.NEXT_PUBLIC_CDN_URL + '/' + image}
          className={`w-full h-full object-cover ${loaded ? 'opacity-100' : 'opacity-0'}`}
          alt={'product-image'}
          width={500}
          height={500}
          onLoad={onLoad}
          onError={() => {
            setImageError(true);
            onLoad(); // Consider it loaded even if there's an error
          }}
          style={{ transition: 'opacity 0.3s ease-in-out' }}
        />
        
        {/* Error state */}
        {imageError && (
          <div className="absolute inset-0 bg-gray-200 flex items-center justify-center">
            <span className="text-gray-500">Failed to load image</span>
          </div>
        )}
      </div>
    </>
  )
}